export const TEL_ANTONIO = "+393397517813";
export const TEL_LUCA = "+393517204660";
export const EMAIL = "artigianidelcotto@gmail.com";
export const ANNO_FONDAZIONE = 1990;
export const ANNI_ESPERIENZA = "oltre trent'anni";

export const WHATSAPP_URL = `https://wa.me/${TEL_ANTONIO.replace("+", "")}`;

// Scheda Google Business Profile
export const GOOGLE_MAPS_URL = "https://maps.google.com/?cid=10239030837478407746";
export const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJSxZwoEBzgUcRQr4rSExYGI4";

export const province = [
  "Brescia",
  "Bergamo",
  "Milano",
  "Monza e Brianza",
  "Cremona",
  "Mantova",
  "Lodi",
  "Pavia",
  "Como",
  "Lecco",
  "Varese",
  "Sondrio",
];
